<template>
  <div>
    <el-col :xs="24" :lg="24" :md="24" :sm="24">
      <div class="product-container">
        <div class="history-table">
          <div class="detail-table-head">
            <div v-for="c in columns" :style="{ width: c.width }">
              {{ c.name }}
            </div>
          </div>
          <div class="detail-table-body">
            <div v-for="(l, key) in r.gift_card_transaction_history_list" :key="key" class="detail-table-row">
              <div v-for="c in columns" :style="{ width: c.width }">
                <template v-if="c.field == 'transaction_money'">
                  <p style="font-size: 16px;padding-bottom: 5px;">{{ l.currency }}{{ l.transaction_amount }}</p>
                </template>
                <template v-else-if="c.field == 'create_time'">
                  <div style="display: flex">
                    <p style="font-size: 16px;">{{ formatter((l[c.field])) }}</p>
                  </div>
                </template>
                <template v-else-if="c.field == 'action'">
                  <div style="display: flex">
                    <el-button size="mini" v-if="r.gift_card_transaction_history_list.length == key + 1"
                      @click="cb">新增</el-button>
                  </div>
                </template>
                <template v-else>
                  <p style="font-size: 16px;">{{ l[c.field] }}</p>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </div>
</template>

<script>
import Order from '../list/Order'
import { API_HOST, FILE_HOST, SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
import { formatterDate } from "../../../services/formatTime";
let _ = require('lodash')

export default {
  name: 'OrderList',
  props: ['r', 'index', 'taskDisplay'],
  components: {
    Order: Order
  },
  data() {
    return {
      columns: [
        { name: '创建时间', field: 'create_time', width: '160px' },
        { name: '创建人', field: 'create_by', width: '100px' },
        { name: '商家单号', field: 'merchant_order_number', width: '100px' },
        { name: '发生额', field: 'transaction_money', width: '100px' },
        { name: '操作', field: 'action', width: '160px' },
      ],
    }
  },
  async mounted() {

  },
  methods: {
    cb() {
      this.$emit('addHistoryPatch')
    },
    formatter(val) {
      return formatterDate(val);
    }
  }
}
</script>

<style lang="scss" scoped>
.product-container {
  padding: 15px 0;
  border-bottom: 1px solid #D7D7D7;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
}

.detail-table-head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D7D7D7;
  padding-bottom: 10px;
}

.detail-table-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D7D7D7;
  padding: 10px 0;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/card/CardBody.vue